import { Store } from 'lucide-react';

/**
 * The store inside a title: its icon (or the `Store` icon when it has none)
 * and its name, sized with the text. A long name moves to the next line as
 * a whole and only wraps between words (Edge Cases).
 */
export function StoreChip({
  name,
  iconUrl,
}: {
  name: string;
  iconUrl?: string | null;
}) {
  return (
    <span className="mx-[0.04em] inline-flex max-w-full items-center gap-[0.22em] rounded-[0.32em] bg-white/[.12] pb-[0.04em] pl-[0.12em] pr-[0.3em] pt-[0.02em] shadow-[inset_0_0_0_1px_rgba(255,255,255,0.18)]">
      {iconUrl ? (
        <img
          src={iconUrl}
          alt=""
          className="block size-[0.78em] flex-none rounded-[0.2em]"
        />
      ) : (
        <Store
          aria-hidden="true"
          className="size-[0.7em] flex-none"
          strokeWidth={1.6}
        />
      )}
      <span className="min-w-0">{name}</span>
    </span>
  );
}
